/* unplugin-vue-components disabled */import script from "./StudentItem.vue?vue&type=script&setup=true&name=GroupItem&lang=js"
export * from "./StudentItem.vue?vue&type=script&setup=true&name=GroupItem&lang=js"

import "./StudentItem.vue?vue&type=style&index=0&id=44290990&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44290990"]])

export default __exports__